import $ from 'jquery';
import selectWithFlag from "./selectWithFlag";

const initSelectsForBlock = (blockSelector, selectConfigs) => {
    const initializedSelects = [];

    // Handle selectWithFlag for specific configs
    selectConfigs.forEach(({ selector, flagText }) => {
        const $select = $(selector);
        if ($select.length) {
            selectWithFlag($select, flagText);
            initializedSelects.push($select[0]); // Store native DOM element
        }
    });

    // Apply Select2 to remaining selects within the block
    $(`${blockSelector} .ginput_container_select select`).each(function () {
        if (!initializedSelects.includes(this)) {
            $(this).find('option[value=""]').prop('disabled', true);
            $(this).select2({
                dropdownPosition: 'below',
                minimumResultsForSearch: -1,
            });
            $(this).on('change', function () {
                $(this).addClass('option-selected');
            });

            if ($(this).val()) {
                $(this).addClass('option-selected');
            }
        }
    });
}


export default initSelectsForBlock;